import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogContent,
  CircularProgress,
  IconButton,
} from "@mui/material";
import React from "react";
import "../css/LogoutConfirmationDialog.css";

const LogoutConfirmationDialog = ({ open, onClose, onSave, isLoading }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        className: "logout-dialog-container",
        sx: { borderRadius: "0px" },
      }}
    >
      <DialogContent>
        <div className="logout-dialog-header">
          <div className="close-button-container">
            <IconButton className="logout-dialog-close" onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </div>
        </div>

        <div className="logout-dialog-content">
          <div className="logout-dialog-title-container">
            <div className="logout-dialog-title">Do you want to logout?</div>
          </div>
          <button
            className="logout-dialog-button logout-yes-button"
            onClick={onSave}
            disabled={isLoading}
          >
            {isLoading ? <CircularProgress size={20} color="inherit" /> : "Yes"}
          </button>
          <button
            className="logout-dialog-button logout-no-button"
            onClick={onClose}
            disabled={isLoading}
          >
            No
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default LogoutConfirmationDialog;
